/**
 * @file Contact Form
 */

/**
 * Contact Form component
 */
const vContactForm = () => {
	const contactForm            = document.querySelector( '.v-contact-form' );
	const contactFormLandingPage = document.querySelector( '.v-contact-form-lp' );

	if ( ! contactForm && ! contactFormLandingPage ) {
		return;
	}

	const body = document.querySelector( 'body' );

	window.addEventListener( 'message', ( event ) => {
		if ( event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit' ) {
			if ( contactForm ) {
				body.classList.add( 'v-contact-form-submitted' );
			} else if ( contactFormLandingPage ) {
				body.classList.add( 'v-contact-form-lp-submitted' );
			}
		}
	} );

	/* const autofill = window.location.search;
	const values   = {
		'request-demo':       'Mortgage originator and want to begin using CreditXpert solutions.',
		'access-creditxpert': 'Other',
	};
	if ( autofill.indexOf( 'aoi=' ) !== -1 ) {
		const value = autofill.match( /aoi=(.*?)(?:&|$)/ );
		if ( values[ value[ 1 ] ] ) {
			const hsForm = contactForm.querySelector( '.v-contact-form__form' );

			window.addEventListener( 'message', ( event ) => {
				if ( event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady' ) {
					const aoi = hsForm.querySelector( `option[value="${ values[ value[ 1 ] ] }"]` );
					if ( aoi ) {
						aoi.parentElement.value = values[ value[ 1 ] ];
					}
				}
			} );
		}
	} */
};

export default vContactForm;
